import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import ServiceManagement from '../pages/Services/Services';
import Login from '../pages/Login';
import PrivateRoute from './PrivateRoute';
import RoleLayout from './RoleLayout';
import AdminStaff from '../pages/AdminStaff';
import PermissionsScreen from '../pages/AdminStaff/PermissionsScreen';
import ChannelPartners from '../pages/ChannelPartners';
import PartnerDetail from '../pages/ChannelPartners/PartnerDetail';
import IdentityQueue from '../pages/ChannelPartners/IdentityQueue';
import ZonesManagement from '../pages/Zones';
import TechnicianManagement from '../pages/Technicians/Technicians';
import Booking from '../pages/Booking/Booking';
import AdsManagement from '../pages/Ads/Ads';
import ManageService from '../pages/Services/ManageService';
import UserManagement from '../pages/Users/Users';
import ManageUser from '../pages/Users/ManageUsers';
import TechnicianDetail from '../pages/Technicians/Details';
import Amc from '../pages/Amc';
import Notifications from '../pages/Notifications';
import BrandManagement from '../pages/Brands';
import FreeConsultancy from '../pages/FreeConsultancy';
import ManageBrand from '../pages/Brands/details';
import Enquiry from '../pages/Enquiry';
import Payment from '../pages/Payments';
import CopperPiping from '../pages/Copperpiping';
import BannerManagement from '../pages/Banners';
import LeavesManagement from '../pages/Leaves';
import { PaymentDetails } from '../pages/Payments/Details';
import { ViewBooking } from '../pages/Booking/actions/Viewbooking';
import AddBooking from '../pages/Booking/actions/Addbooking';
import { AssignBooking } from '../pages/Booking/actions/Assignbooking';
import { UserHistory } from '../pages/Users/History';
import { TechcieHistoryComp } from '../pages/Technicians/History';
import ToolManagement from '../pages/Tools';
import LeadsManagement from '../pages/Leads';
import TonnageCalculator from '../pages/TonnageCalculator';
import Comparison from '../pages/Comparison';
import SellOldAC from '../pages/SellOldAC';
import PromotionPage from '../pages/Promotion'; // Make sure this path is correct
import Product from '../pages/Product';
import ProductDetails from '../components/common/productdetails';
import AddProduct from '../components/common/AddProduct';
import RequestDetails from '../pages/Amc/AMCRequest';
import AMCRequest from '../pages/Amc/AMCRequest';
import CopperPipingRequest from '../pages/Copperpiping/CopperPipingRequest';
import ConsultancyRequest from '../pages/FreeConsultancy/ConsultancyRequest';
import Purchase from '../pages/Purchase';
import LeadDetailsPage from '../pages/Purchase/LeadDetailsPage';
import MaterialTable from '../pages/Material/MaterialTable';
import ToolList from '../pages/ManageTools/ToolList';
import TaxationList from '../pages/Taxation/TaxationList';
import ACD_helper from '../pages/ACD_helper/ACD_helper';
import SellRequestDetail from '../pages/SellOldAC/RequestDetail';
import ACD_technician from '../pages/ACD_technician/ACD_technician';
import Contractor from '../pages/Contractor/Contractor';
import ToolRequest from '../pages/ToolRequest/ToolRequest';
import Cancelled from '../pages/Cancelled';
import TechnicianAttendance from '../pages/Technicians/Attendance';
import NewJoinTechnicians from '../pages/Technicians/NewJoin';
import HolidaysManagement from '../pages/Holidays';

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route element={<RoleLayout />}>
            <Route path="home" element={<Dashboard />} />
            <Route path="enquires" element={<Enquiry />} />
            <Route path="payments" element={<Payment />} />
            <Route path="payments/:paymentId" element={<PaymentDetails />} />
            <Route path="customers" element={<UserManagement />} />
            <Route path="customers/:userId" element={<ManageUser />} />
            <Route
              path="customers/history/:bookingId"
              element={<UserHistory />}
            />
            <Route path="zones" element={<ZonesManagement />} />
            <Route path="technicians" element={<TechnicianManagement />} />
            <Route
              path="technicians/attendance"
              element={<TechnicianAttendance />}
            />
            <Route
              path="technicians/new-join"
              element={<NewJoinTechnicians />}
            />
            <Route
              path="technicians/:technicianId"
              element={<TechnicianDetail />}
            />
            <Route
              path="technician/history/:bookingId"
              element={<TechcieHistoryComp />}
            />
            {/* IMPORTANT: Use PromotionPage at /promotions */}
            {/* <Route path="promotions" element={<PromotionPage />} /> */}
            {/* Remove the commented line below */}
            <Route path="promotions" element={<Notifications />} />
            <Route path="technicians/tools" element={<ToolManagement />} />
            <Route path="manage/services" element={<ServiceManagement />} />
            <Route path="manage/services/create" element={<ManageService />} />
            <Route
              path="manage/services/:serviceId"
              element={<ManageService />}
            />
            <Route path="bookings" element={<Booking />} />
            <Route path="bookings/create" element={<AddBooking />} />
            <Route
              path="bookings/:bookingId"
              element={<ViewBooking type="VIEWDETAIL" />}
            />
            <Route
              path="bookings/assign/:bookingId"
              element={<AssignBooking />}
            />
            <Route path="bookings/edit/:bookingId" element={<AddBooking />} />
            <Route path="manage/leaves" element={<LeavesManagement />} />
            <Route path="manage/holidays" element={<HolidaysManagement />} />
            <Route path="manage/coupons" element={<AdsManagement />} />
            <Route path="manage/brand-errors" element={<BrandManagement />} />
            <Route path="manage/banners" element={<BannerManagement />} />
            <Route
              path="manage/brand-errors/:brandId"
              element={<ManageBrand />}
            />
            <Route path="request/amc" element={<Amc />} />
            <Route path="/amc/request-details/:id" element={<AMCRequest />} />
            <Route
              path="request/free-consultancy"
              element={<FreeConsultancy />}
            />
            <Route
              path="/free-consultancy/request-details/:id"
              element={<ConsultancyRequest />}
            />
            <Route path="/purchase" element={<Purchase />} />
            <Route
              path="purchase/lead-details/:purchaseLeadId"
              element={<LeadDetailsPage />}
            />
            <Route path="request/copperpiping" element={<CopperPiping />} />
            <Route
              path="/copperpiping/request-details/:id"
              element={<CopperPipingRequest />}
            />
            <Route path="leads" element={<LeadsManagement />} />
            <Route path="utility/error-codes" element={<BrandManagement />} />
            <Route path="manage/brand-errors" element={<BrandManagement />} />
            <Route
              path="utility/tonnage-calculator"
              element={<TonnageCalculator />}
            />
            <Route path="/products/edit/:id" element={<AddProduct />} />
            <Route path="/add-product" element={<AddProduct />} />
            <Route path="utility/comparison" element={<Comparison />} />
            <Route path="request/sell-old-ac" element={<SellOldAC />} />
            <Route path="/Product" element={<Product />} />
            <Route path="/productdetails/:id" element={<ProductDetails />} />
            <Route path="manage/material" element={<MaterialTable />} />
            <Route path="manage/tools" element={<ToolList />} />
            <Route path="manage/taxation" element={<TaxationList />} />
            <Route path="technicians/acd-helper" element={<ACD_helper />} />
            <Route
              path="technicians/acd-technicians"
              element={<ACD_technician />}
            />
            <Route path="technicians/contractor" element={<Contractor />} />
            <Route path="request/detail" element={<SellRequestDetail />} />
            <Route path="technicians/tool-request" element={<ToolRequest />} />
            <Route path="cancelled" element={<Cancelled />} />
            <Route path="admin-staff" element={<AdminStaff />} />
            <Route path="admin-staff/:id/permissions" element={<PermissionsScreen />} />
            <Route path="channel-partners" element={<ChannelPartners />} />
            <Route path="channel-partners/identity" element={<IdentityQueue />} />
            <Route path="channel-partners/:id" element={<PartnerDetail />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
